export default __webpack_public_path__ + "static/media/jahaziel.f3cdf9e6.jpg";